// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdp-root {
  width: 100%;
}

/* Only apply border-bottom to first month when there are multiple months */
.vertical-months .rdp-month:nth-child(1):not(:last-child) {
  border-bottom: 1px solid #e2e4e7; /* Divider line */
  padding-bottom: 0.25rem;
}

.rdp-month_caption {
  font-weight: 500;
  font-size: 16px;
  height: 40px;
  padding: 8px 8px 8px 8px;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-style: normal;
}

@media (min-width: 375px) {
  .rdp-month_caption {
    padding: 8px 0px 8px 0px;
  }
}

@media (min-width: 1024px) {
  .rdp-month_caption {
    padding: 16px 0 8px 0;
    font-size: 18px;
  }
}

.rdp-month_grid {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 4px;
}

.hidden-weekday {
  display: none;
}

.rdp-day {
  height: 44px;
  text-align: center;
  padding: 0px;
}

.rdp-today:not(.rdp-outside) {
  color: black !important;
}

.hidden-day {
  display: none !important;
}

.rdp-day_button {
  background: none;
  padding: 4px;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  height: 44px;
  border: 0px;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
}

.rdp-day_button:focus-visible {
  box-shadow: 0 0 0 2px #165b76;
  border-radius: 4px;
}

.rdp-day_button[disabled] {
  color: black !important;
  text-decoration: underline;
  background-color: #f8f8f9;
  opacity: 1;
  border-radius: 0%;
  font-weight: 700;
}

.rdp-disabled {
  opacity: 1;
}

.highlight-range {
  background-color: #dae6ee;
}

.selected-date {
  background-color: #165b76;
  color: white;
  border-radius: 0 4px 4px 0;
}

.first-date {
  background-color: #f8f8f9;
}

.rdp-week {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MonthlySubscriptionDayPicker/monthlySubscriptionDayPicker.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,gCAAgC,EAAE,iBAAiB;EACnD,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".rdp-root {\n  width: 100%;\n}\n\n/* Only apply border-bottom to first month when there are multiple months */\n.vertical-months .rdp-month:nth-child(1):not(:last-child) {\n  border-bottom: 1px solid #e2e4e7; /* Divider line */\n  padding-bottom: 0.25rem;\n}\n\n.rdp-month_caption {\n  font-weight: 500;\n  font-size: 16px;\n  height: 40px;\n  padding: 8px 8px 8px 8px;\n  font-family: 'Roboto', Arial, Helvetica, sans-serif;\n  font-style: normal;\n}\n\n@media (min-width: 375px) {\n  .rdp-month_caption {\n    padding: 8px 0px 8px 0px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .rdp-month_caption {\n    padding: 16px 0 8px 0;\n    font-size: 18px;\n  }\n}\n\n.rdp-month_grid {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 4px;\n}\n\n.hidden-weekday {\n  display: none;\n}\n\n.rdp-day {\n  height: 44px;\n  text-align: center;\n  padding: 0px;\n}\n\n.rdp-today:not(.rdp-outside) {\n  color: black !important;\n}\n\n.hidden-day {\n  display: none !important;\n}\n\n.rdp-day_button {\n  background: none;\n  padding: 4px;\n  margin: 0;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  height: 44px;\n  border: 0px;\n  width: 100%;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.rdp-day_button:focus-visible {\n  box-shadow: 0 0 0 2px #165b76;\n  border-radius: 4px;\n}\n\n.rdp-day_button[disabled] {\n  color: black !important;\n  text-decoration: underline;\n  background-color: #f8f8f9;\n  opacity: 1;\n  border-radius: 0%;\n  font-weight: 700;\n}\n\n.rdp-disabled {\n  opacity: 1;\n}\n\n.highlight-range {\n  background-color: #dae6ee;\n}\n\n.selected-date {\n  background-color: #165b76;\n  color: white;\n  border-radius: 0 4px 4px 0;\n}\n\n.first-date {\n  background-color: #f8f8f9;\n}\n\n.rdp-week {\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
